import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Button, ButtonProps } from '@mui/material';

export interface AddActionButtonProps extends Omit<ButtonProps, 'children' | 'startIcon'> {
    label: string;
}

const AddActionButton = ({ label, sx, ...props }: AddActionButtonProps) => (
    <Button
        variant="contained"
        size="small"
        startIcon={<AddRoundedIcon fontSize="small" />}
        aria-label={props['aria-label'] ?? label}
        sx={{
            minHeight: 36,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            fontWeight: 700,
            ...sx,
        }}
        {...props}
    >
        {label}
    </Button>
);

export default AddActionButton;
